import { useCallback } from 'react'

import { ConfirmationModal } from 'govwell-ui'

import { useDismissAIChatbotFAQMutation } from 'src/fetch/aiChatbotFAQ'
import { RefetchFnType } from 'src/types'

type Props = {
  id: number
  onClose: () => void
  refetch: RefetchFnType
}
const DismissQuestionModal = ({ id, onClose, refetch }: Props) => {
  const { mutateAsync: dismissAIChatbotFAQ } = useDismissAIChatbotFAQMutation()
  const handleDismiss = useCallback(async () => {
    await dismissAIChatbotFAQ({ id })
  }, [dismissAIChatbotFAQ, id])

  const handleClosed = useCallback(async () => {
    await refetch()
  }, [refetch])

  return (
    <ConfirmationModal
      title="Dismiss Question"
      cancelText="Cancel"
      confirmText="Dismiss question"
      isDestructive
      onCancel={onClose}
      onConfirm={handleDismiss}
      onClosed={handleClosed}
    >
      Are you sure you want to dismiss this question?
    </ConfirmationModal>
  )
}

export default React.memo(DismissQuestionModal)
